import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Colors } from '../constants/Colors';
import { useDynamicStyles } from '../hooks';
import type { WithResponsive } from '../utils/responsivity';
import { TextReg } from './StyledText';

type Props = {
  message: string | null;
};

export function FormValidationBanner({ message }: Props) {
  const styles = useDynamicStyles(createStyles);

  if (!message) {
    return null;
  }

  return (
    <View style={styles.container}>
      <TextReg style={styles.text}>{message}</TextReg>
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: isMobile ? 8 : 12,
      padding: isMobile ? 12 : 16,
      backgroundColor: Colors.purple0,
      borderRadius: isMobile ? 12 : 16,
      borderWidth: 1,
      borderColor: Colors.yellow0,
    },
    text: {
      color: Colors.placeholderText,
      textAlign: 'center',
      fontSize: isMobile ? 10 : 12,
    },
  });
